import React, { useEffect } from "react";
import OnboardingHeader from "./OnboardingHeader";
import StepProgressBar from "./StepProgressBar";
import OnboardingCard from "./OnboardingCard";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { updateStage } from "../../store/reducers/stageReducer";
import { useUpdateStagesMutation } from "../../services/api";
import { tracker } from "../../services/mixpanel";

const STEP_KEY = "presentationComplete" as const;

const OnboardingPresentation = () => {
  const dispatch = useAppDispatch();
  const [updateStages] = useUpdateStagesMutation();
  const zohoCustomerId = useAppSelector((state) => state.login.zohoCustomerId);

  const next = async () => {
    await updateStages({ zohoId: zohoCustomerId, key: STEP_KEY }).unwrap();
    dispatch(updateStage({ [STEP_KEY]: true }));
  };

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data === "presentationComplete") {
        tracker.steps.presentation.complete();
        next();
      } else if (event.data && event.data.type === "presentationStep") {
        tracker.steps.presentation.step(event.data.step);
      }
    };

    window.addEventListener("message", handleMessage);
    tracker.steps.presentation.start();

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <OnboardingHeader />

      <main className="w-full max-w-5xl mx-auto pt-10 px-10">
        <StepProgressBar stepKey={STEP_KEY} />

        <div className="mt-6 flex flex-col items-center">
          <h1 className="font-['Canela_Text',_serif] font-bold text-3xl uppercase text-[#000000] text-center">
            Interactive Presentation
          </h1>

          <div className="mt-6 w-full max-w-5xl">
            <div className="w-full relative aspect-video bg-black border-[1.27px] border-[#A2B2C833] overflow-hidden shadow-lg">
              <iframe
                src="/InceptionPresentation/index.html"
                className="w-full h-full absolute top-0 left-0"
                style={{ border: "none" }}
                title="Inception Presentation"
                id="inceptionIframe"
              />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default OnboardingPresentation;